module.exports = __webpack_public_path__ + "static/media/engineer.9aa32f28.jpg";